import {View} from '@packages/systems/spring';
import {ComponentsCodeIcon} from '@packages/systems/spring-branded';
import {AddPluginItem} from '@packages/systems/ui/shared-ui/AddPluginItem';
import {tokens} from '@packages/utilities/styled';
import React, {useCallback, useState} from 'react';
import {useVccEntrypointTracking} from '../useVccEntrypointTracking';
import {openCreateCodeComponentModal} from './createCodeComponentModalStore';

export const CODE_COMPONENT_TILE_LABEL = 'Code Component';

// Neutral take on the branded icon, per the Add panel design. The -2px
// margins keep the 40px icon at the 36px height the other tiles use.
const TILE_ICON_STYLE = {
  marginTop: -2,
  marginBottom: -2,
  '--colors-brand-icon-outline': tokens.colors.border1,
  '--colors-brand-icon-focus': 'currentColor',
  '--colors-brand-icon-detail': tokens.colors.border3,
} as React.CSSProperties;

const CodeComponentTileIcon = () => (
  <View color="$textPrimary">
    <ComponentsCodeIcon
      data-component="add-panel-icon"
      size="40px"
      style={TILE_ICON_STYLE}
    />
  </View>
);

const SEARCH_TEXT = `${CODE_COMPONENT_TILE_LABEL} react code`.toLowerCase();

export function matchesCodeComponentTileQuery(query: string): boolean {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  return words.length > 0 && words.every((word) => SEARCH_TEXT.includes(word));
}

/**
 * Opens the paste modal instead of inserting an element, so it is not
 * draggable and does not go through the element preset handlers.
 */
export const CodeComponentAddPanelTile = () => {
  const [isHovered, setIsHovered] = useState(false);
  const {onCtaClick} = useVccEntrypointTracking('add_panel');

  const handleClick = useCallback(() => {
    onCtaClick();
    openCreateCodeComponentModal('add_panel');
  }, [onCtaClick]);

  return (
    <AddPluginItem
      data-automation-id="add-tab-CodeComponent"
      hover={isHovered}
      icon={<CodeComponentTileIcon />}
      name={CODE_COMPONENT_TILE_LABEL}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );
};
